import miniatureMap from '../miniatures/miniatures.json' ;
//logo_cd42.webp
const images = require.context('../miniatures/');

const getMiniatureFromAideName = function  ( aide ){
	//console.log(aide);
	if (!miniatureMap.hasOwnProperty(aide)){
		return images( './'+ miniatureMap["aides . bonus vélo"]) ;
	}
		
	return images( './'+ miniatureMap[aide]) ;
}

export {getMiniatureFromAideName};